import * as payApi from "../api/pay"
import * as utilsApi from "../api/utils"
import * as request from "../utils/request"
import * as helper from "../utils/helper"
export function placeOrder({
  loginState,
  offerId,
  sandbox,
  userAgent,
  pf,
  zoneid,
  gameId,
  productId,
  productNum,
  productName,
  extendParams
}) {
  // let userAgent = ua.getUserAgent(),
  //       //   gameId
  /*
  gameid区分端游和手游拼接模式
  端游为 "大区id_角色id"
  手游为 "area(标识手Q还是微信)_角色id__分区id"
   */

  //mds_pay_ingame 30142
  const pfSource = userAgent.msdk ? "mds_pay_ingame" : "mds_wechat_gmshop"
  // gameId = [state.selectedZone.c || (userAgent.weixin ? "1" : "2"), "", "", state.selectedZone.v].join("_")
  let params = {
    pf: `${pfSource}-pay_html5_${pf}-${userAgent.iOS ? "iap" : "android"}`,
    offerId: offerId,
    sandbox: sandbox,
    ...loginState
  }
  let extend = {
    is_filter_goods: 1,
    change_openid: 1,
    gameid: gameId,
    game_platform_id: userAgent.iOS ? 0 : 1,
    is_v3_price: 1,
    zoneid,
    payitem: [productId, productNum, offerId].join("*"),
    // is_bargain: 1,
    change_wx_openid: 1,
    goodsmeta: encodeURIComponent(productName) + "*desc",
    ...extendParams
  }
  return payApi.placeOrder(params, extend)
}

export function midasPay({ loginState, offerId, userAgent, sandbox, pf, token, mid, realPrice, directChannel, drm_info }) {
  return utilsApi.initMidas().then(Midas => {
    return new Promise((resolve, reject) => {
      const pfSource = helper.getPfSource()

      let data = {
        params: `/v1/${mid}/${offerId}/mobile_goods_info?token_id=${token}`,
        pf: `${pfSource}-pay_html5_${pf}-${userAgent.iOS ? "iap" : "android"}`,
        sandbox: sandbox,
        // drm_info: `bargain_group=${config.ACTIVITY[offerId]}&version=3.0&bargain_id=${bargainId}`,
        drm_info,
        openid: loginState.openid,
        openkey: loginState.openkey,
        sessionid: loginState.session_id,
        sessiontype: loginState.session_type,
        wxAppid2: loginState.wx_appid,
        closeOnSuccess: 1,
        hideUi: 1,
        hidePrice: 1,
        showCoin: 1,
        supercoupons: "noCoupon", //先屏蔽抵扣券使用
        realPrice,
        dc: "bank,mcard,hfpay,yb,wsjpay,qqcard",
        // directChannel: "wechat",
        onSuccess: resolve,
        onClose: reject
      }

      if (userAgent.weixin) {
        data.change_wx_openid = 1
      }
      if (userAgent.iOS || userAgent.weixinminiprogram) {
        //iOS内屏蔽微信渠道
        data.dc = `${data.dc},wechat,qqwallet,qdqb,qbqd`
        data.directChannel = "game_coin"
      }
      // if (userAgent.msdk) {
      //   //msdk内屏蔽现金渠道
      //   data.dc = `${data.dc},wechat,qqwallet,qdqb,qbqd`
      //   data.directChannel = "game_coin"
      //   data.buyGameInfo = "disableReflow=1"
      // }
      if (directChannel) {
        data.directChannel = directChannel
        if (directChannel == "game_coin") {
          data.dc = `${data.dc},wechat,qqwallet,qdqb,qbqd`
        }
      }
      Midas.buyGoods(data)
    })
  })
}

export function miniProgramPay({ sandbox, uuid, userAgent, loginState, offerId, token, mid, groupid }) {
  /**
   * 跳转小程序支付参数说明
   * offerid || goodstokenurl || openid || groupid || buy_quantity || change_wx_openid || pf
   * unit || service_code || identity || wx_appid || zoneid（rechargeInfo里） || product_name（rechargeInfo里）
   * 以上参数支付使用
   *
   * singleton || gameid || productId || offerid
   * 当singleton=1时 结果页缓存已购买信息使用
   *
   * rechargeInfo里 n || accountType || account || name || categoryId || zoneName || action || returnBackText || groupId || busId
   * 结果页展示信息
   * 搭配 goOtherResult
   * 标识回到商店结果页
   */

  let goodstokenurl = encodeURIComponent(`/v1/${mid}/${offerId}/mobile_goods_info?token_id=${token}`)

  let miniPayParam = {
    offerid: offerId,
    goodstokenurl: goodstokenurl,
    openid: decodeURIComponent(loginState.openid),
    groupid: groupid ? decodeURIComponent(groupid) : "",
    buy_quantity: "",
    sandbox,
    change_wx_openid: 1,
    pf: userAgent.iOS ? "iap" : userAgent.android ? "android" : "html5",
    unit: "",
    service_code: "",
    goOtherResult: 2,
    cgiExtend: encodeURIComponent(`uuid=${uuid}&pushtype=NodeJS`),
    wx_appid: decodeURIComponent(loginState.wx_appid ? loginState.wx_appid : "")
  }

  // eslint-disable-next-line no-undef
  wx.miniProgram.navigateTo({
    url: "/webview/pages/pay/pay?" + request.serializeParams(miniPayParam)
  })
  return request.comet({
    sandbox: sandbox,
    data: {
      uin: loginState.openid,
      skey: loginState.openkey,
      uuid,
      tag: "wzry_activity_comet"
    }
  })
}
